import React, { useState, useEffect } from 'react'
import { AlertProvider } from './megamind/context/AlertContext';
import { useAuth } from './megamind/context/AuthContext'
import { Route, Routes } from 'react-router'

import AdminRoutes from './megamind/routes/AdminRoutes'
import AuthRoutes from './megamind/routes/AuthRoutes'

import LogoutPage from './megamind/app/auth/pages/LogoutPage';
import Error404Page from './megamind/app/errorPages/Error404Page';
import Error401Page from './megamind/app/errorPages/Error401Page';
import ChangePasswordPage from './megamind/app/auth/pages/ChangePasswordPage';
import { MqttProvider } from './megamind/context/MqttContext';


function App() {
    const {isLoggedIn,authUser} = useAuth();
    speechSynthesis.getVoices();
    //console.log("authUSerrole", authUser)
    sessionStorage.removeItem("businessInfo");

    // Disable Right Click Start
    /*
    useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])
    */
    // Disable Right Click End
    
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <>
                <MqttProvider>
                    { authUser.role == 1 &&
                        <AdminRoutes/>
                    }
                    <Routes>
                        {/*Logout */}
                        <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                        <Route path="/auth/change-password" element={<ChangePasswordPage />}></Route>
                        <Route path="/404" element={<Error404Page/>}></Route>
                        <Route path="/401" element={<Error401Page/>}></Route>
                    </Routes> 
                </MqttProvider>
                </>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App